export default __webpack_public_path__ + "4df928da13bf5809376c3a63e663e333.png";